import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  pendingRequestsSent = new EventEmitter();
  pendingRequestsSending = new EventEmitter<number>();
  pendingRequestsChanged = new EventEmitter<number>();
  networkStatusChanged = new EventEmitter<boolean>();
  dataSynchronized = new EventEmitter();
  longestResponseTimeChanged = new EventEmitter<number>();

  constructor() {}
}
